/**
 * 진입 화면 자동 이어하기(`/api/me`)가 실패했을 때 무엇을 할지(부검 2026-10-26).
 *
 * 🚨 종전에는 410 이 아니면 전부 접속 정보를 지웠다. 10-26 13:57 `/api/me` 500 한 번
 *    (안쪽 조회가 Cloudflare 502)으로 유효한 토큰을 가진 학생이 수업 코드를 다시 넣어야 했다.
 *    같은 지적이 10-08·10-12·10-14·10-26 네 번 나왔다.
 *
 * - `ended` = 410. 수업이 끝났다.
 * - `clear` = 401·403·404. 토큰이 무효이거나 그 작품이 이 토큰의 것이 아니다 — 다시 시도해도 같다.
 * - `retry` = 그 밖 전부(5xx·429·네트워크 오류). 토큰은 멀쩡할 수 있으니 지우지 않는다.
 */
export type ResumeFailureAction = "ended" | "clear" | "retry";

export function resumeFailureAction(error: unknown): ResumeFailureAction {
  const status = typeof error === "object" && error && "status" in error ? (error as { status: unknown }).status : null;
  if (status === 410) return "ended";
  if (status === 401 || status === 403 || status === 404) return "clear";
  return "retry";
}

/** 자동 재시도 간격(ms). 다 써도 실패하면 학생에게 「다시 시도」 버튼을 보인다. */
export const RESUME_RETRY_DELAYS_MS: readonly number[] = [1_000, 3_000];
